module.exports = __webpack_public_path__ + "img/img-dashboards-dark-theme.42ccea2f.svg";